'use strict';

const jQuery = require('jquery');
const _ = require('lodash');

const FormBuilder = require('./../../builder');

const tplItem = require('./template/social_item.hbs');

let ElementClass = require('./../../elementClass');

FormBuilder.register('social', function(config) {
    let self = {};

    self = new ElementClass(config);

    self.value = config.value;

    self.onClick = function() {
        let $span = jQuery(this);
        let $parent = $span.closest('div.cloud-group');

        $parent.find('div.cloud-input').toggleClass('d-none');
    };

    self.render = function($wrap) {
        _.each(self.value, function(element, key) {
            element.trans = 'social_' + key;

            let $tpl = jQuery(tplItem({
                'element': element,
                'key': key,
            }));

            $tpl.find('.cloud-switch-indicator').on('click', self.onClick);

            $wrap.append($tpl);
        });

        return;
    };

    self.getData = function() {
        let data = self.value;

        self.$.find('input[type="text"]').each(function() {
            let $input = jQuery(this);
            let key = $input.attr('name');
            let url = $input.val();

            if (!url.match(/^[a-zA-Z]+:\/\//) && url.substr(0, 1) !== '/') {
                url = 'https://' + url;
            }

            data[key].url = url;
        });

        self.$.find('input[type="checkbox"]').each(function() {
            let $checkbox = jQuery(this);
            let key = $checkbox.attr('name').replace('_check', '');

            data[key].enable = Boolean($checkbox.is(':checked'));
        });

        return data;
    };

    return self;
});
